import { Component, OnInit, inject, input } from '@angular/core';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { InvoicePositionModel } from '../../../../../core/models/finance/financial-record.model';
import { ShiveDialogService } from '../../../../../core/services/controls/shive-dialog.service';
import { FormControlNameRecord } from '../../../../../shared/data-types/form-types';
import { editorFontFamilies } from '../../../../../shared/text-editor/configuration';
import { editorPlugins } from '../../../../../shared/text-editor/plugins/wysiwyg-editor-plugins';

@Component({
  selector: 'app-edit-invoice-position-dialog',
  templateUrl: './edit-invoice-position-dialog.component.html',
  standalone: false,
})
export class EditInvoicePositionDialogComponent implements OnInit {
  financialRecordPosition = input.required<InvoicePositionModel>();
  public invoicePositionForm: FormGroup;
  public formControlNames: FormControlNameRecord = {
    Description: 'description',
    Price: 'price',
  };
  public readonly faPenToSquare = faPenToSquare;
  public readonly editorFontFamilies = editorFontFamilies;
  public readonly editorPlugins = editorPlugins;

  private readonly formBuilder = inject(NonNullableFormBuilder);
  private readonly shiveDialogService = inject(ShiveDialogService);

  ngOnInit(): void {
    this.invoicePositionForm = this.formBuilder.group({
      [this.formControlNames.Description]: [this.financialRecordPosition().description],
      [this.formControlNames.Price]: [this.financialRecordPosition().price],
    });
  }

  public submit(): void {
    const formData = this.invoicePositionForm.value;

    const updatedInvoicePosition = new InvoicePositionModel();
    updatedInvoicePosition.id = this.financialRecordPosition().id;
    updatedInvoicePosition.timeBlockIds = this.financialRecordPosition().timeBlockIds;
    updatedInvoicePosition.price = formData.price;
    updatedInvoicePosition.description = formData.description;

    this.shiveDialogService.close(updatedInvoicePosition);
  }

  public close(): void {
    this.shiveDialogService.close();
  }
}
